export default __webpack_public_path__ + "static/media/SolarPV_Klauzula.9d35ab15.pdf";